import React, { Component } from "react";

import "./LogosCampanha.css";

export default class LogosCampanha extends Component {
	render() {
		let campanha = this.props.campanha;
		let logoCentro = null;
		if (!campanha.logoLeft || !campanha.logoRight) {
			logoCentro = campanha.logoLeft || campanha.logoRight;
		}

		return (
			<div className="campanha_logosTopo">
				{logoCentro ? (
					<img
						className="campanha_logosTopo__centro"
						src={logoCentro}
						alt="Logo campanha esquerda"
					/>
				) : (
					<div>
						{campanha.logoLeft ? (
							<img
								className="campanha_logosTopo_left"
								src={campanha.logoLeft}
								alt="Logo campanha esquerda"
							/>
						) : null}
						{campanha.logoRight ? (
							<img
								className="campanha_logosTopo_right"
								src={campanha.logoRight}
								alt="Logo campanha direita"
							/>
						) : null}
					</div>
				)}
				<br style={{ clear: "both" }} />
				<div className="campanha_logosTopo_name foreground">
					<b>{campanha.name}</b>
				</div>
				{campanha.title ? (
					<div className="campanha_logosTopo_subtitle foreground">{campanha.title}</div>
				) : null}
				{campanha.subtitle ? (
					<div className="campanha_logosTopo_subtitle foreground">{campanha.subtitle}</div>
				) : null}
				<div className="campanha_logosTopo_client foreground">{campanha.client.name}</div>
			</div>
		);
	}
}
